import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Controller } from "react-hook-form";

import { SmallFields, TextField } from "../theme";
import PlaceAutocomplete from "./PlaceAutocomplete";

const Fieldset = styled.fieldset`
  display: ${(props) => (props.isDisplayed ? "block" : "none")};
`;

function AddressField({ control, errors, getValues, setValue }) {
  const [isAutocomplete, setIsAutocomplete] = useState(
    () => getValues().street !== undefined && getValues().street.length !== 0
  );

  function handleAutocompleteSelection(address) {
    setValue(
      "street",
      `${address.number ? address.number + " " : ""}${address.street}`
    );
    setValue("postal_code", address.zipcode);
    setValue("locality", address.city);
    setValue("country_name", address.country);
    setIsAutocomplete(true);
  }

  return (
    <>
      <Fieldset isDisplayed={!isAutocomplete}>
        <PlaceAutocomplete
          onSelection={handleAutocompleteSelection}
          isRequired={!isAutocomplete}
          error={
            errors.street &&
            `L'adresse postale est requise. Choisissez une option dans le menu déroulant. Si aucune n'est valide choisissez en une autre et vous pourrez la modifier ensuite.`
          }
        />
      </Fieldset>
      <SmallFields>
        <Fieldset isDisplayed={isAutocomplete}>
          <Controller
            as={TextField}
            label="Adresse postale"
            name="street"
            control={control}
            required={isAutocomplete}
            rules={{
              required: "L'adresse postale est requise.",
            }}
            error={errors.street !== undefined}
            helperText={errors.street && errors.street.message}
          />
        </Fieldset>
        <Fieldset isDisplayed={isAutocomplete}>
          <Controller
            as={TextField}
            label="Code postal"
            name="postal_code"
            control={control}
            required={isAutocomplete}
            rules={{
              required: "Le code postal est requis.",
            }}
            error={errors.postal_code !== undefined}
            helperText={errors.postal_code && errors.postal_code.message}
          />
        </Fieldset>
      </SmallFields>
      <SmallFields>
        <Fieldset isDisplayed={isAutocomplete}>
          <Controller
            as={TextField}
            label="Ville"
            name="locality"
            control={control}
            required={isAutocomplete}
            rules={{
              required: "La ville est requise.",
            }}
            error={errors.locality !== undefined}
            helperText={errors.locality && errors.locality.message}
          />
        </Fieldset>
        <Fieldset isDisplayed={isAutocomplete}>
          <Controller
            as={TextField}
            label="Pays"
            name="country_name"
            control={control}
            required={isAutocomplete}
            rules={{
              required: "Le pays est requis.",
            }}
            error={errors.country_name !== undefined}
            helperText={errors.country_name && errors.country_name.message}
          />
        </Fieldset>
      </SmallFields>
    </>
  );
}

AddressField.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.shape({
    street: PropTypes.shape({
      message: PropTypes.string,
    }),
    postal_code: PropTypes.shape({
      message: PropTypes.string,
    }),
    locality: PropTypes.shape({
      message: PropTypes.string,
    }),
    country_name: PropTypes.shape({
      message: PropTypes.string,
    }),
  }).isRequired,
  getValues: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};

export default AddressField;
